import { Button, Chip, FormHelperText, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { Dispatch, SetStateAction, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import {
  CLOSE_VA_ANNOUNCEMENT,
  TERMS_AND_CONDITIONS_LINK_YEARLY,
} from "constants/influencer";
import { trackEvent } from "utils/tracking";

import styles from "./styles";

interface Props {
  close: boolean;
  setClose: Dispatch<SetStateAction<boolean>>;
}

const VAAnnouncement = ({ close, setClose }: Props) => {
  const navigate = useNavigate();
  const { currentOrg } = useContext(OrganizationUserContext);
  const closeFromSessionStorage =
    sessionStorage.getItem(`${CLOSE_VA_ANNOUNCEMENT}-${currentOrg?.id}`) ===
    "true";
  const { subscription } = useContext(SubscriptionContext);
  const isMonthlyVa =
    subscription?.isSubscribed &&
    subscription?.subscription?.planName === Plans.VA;

  const trackLearnMore = () => {
    trackEvent("Virtual Assistant Money Back - Learn More Clicked", {
      source: "Banner",
    });
    navigate(`/${routes.vaAnnual}`);
  };

  const trackTermsAndCondition = () => {
    trackEvent("Virtual Assistant Money Back - Terms & Conditions Clicked", {
      clickedFrom: "Banner",
    });
  };

  useEffect(() => {
    if (closeFromSessionStorage && !close) {
      setClose(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeFromSessionStorage]);

  return (
    <Grid container item xs sx={styles.container} alignItems="center" gap={2}>
      <Grid item xs={12} md>
        <Typography
          component="div"
          variant="h6"
          sx={{ mb: 1, fontSize: { xs: 15, sm: 16 } }}
        >
          🏇{" "}
          {isMonthlyVa
            ? "Want to lock in Virtual Assistant and a money back guarantee?"
            : "Want a Virtual Assistant to pitch for you?"}
          {!isMonthlyVa && (
            <Chip
              size="small"
              sx={{
                backgroundColor: "primary.main",
                color: "white",
                fontSize: 12,
              }}
              label="Money back guaranteed 💸"
            />
          )}
        </Typography>

        <Typography
          sx={{ color: grey[700], fontSize: { xs: 12, sm: 14 } }}
          gutterBottom
        >
          {isMonthlyVa ? (
            "Labor Day Sale: Upgrade to an annual plan by Sept 2, and if you don't earn more than you pay in your first year, we'll refund you."
          ) : (
            <>
              300+ emails sent for you every month.{" "}
              <strong>Labor Day Sale:</strong> If you don't earn more than you
              pay in your first year, we'll <strong>refund</strong> you.
            </>
          )}
        </Typography>

        <FormHelperText
          sx={{
            color: grey[700],
            mt: { xs: 0.5, sm: 1 },
            fontSize: { xs: 10, sm: 12 },
          }}
        >
          <a
            href={TERMS_AND_CONDITIONS_LINK_YEARLY}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackTermsAndCondition}
          >
            Terms & Conditions Apply
          </a>
        </FormHelperText>
      </Grid>

      <Grid item xs md="auto" sx={{ textAlign: { xs: "center", sm: "left" } }}>
        <Button
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "info.main",
            textTransform: "none",
          }}
          onClick={trackLearnMore}
        >
          Learn More
        </Button>
        <FormHelperText>
          <em>Expires Sept 2, 2025</em>
        </FormHelperText>
      </Grid>
    </Grid>
  );
};

export default VAAnnouncement;
